module.exports = __webpack_public_path__ + "static/media/notebook1.b8649bec.png";